module.exports = __webpack_public_path__ + "img/product-photo-coming-soon.c6742d6b.jpg";